/**
 * Format version display string based on app version, stage, and commit SHA.
 * Shows short commit SHA for local/dev stages only.
 */
export function getVersionDisplay(): string {
  const version = `v${__APP_VERSION__}`;
  const stage = __APP_STAGE__;
  const sha = __COMMIT_SHA__;

  // For local/dev, show short commit SHA if available
  if ((stage === 'local' || stage === 'dev') && sha) {
    return `${version}-${sha.slice(0, 7)} · ${stage}`;
  }

  return `${version} · ${stage}`;
}
